import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastaService, ToastaConfig } from 'ngx-toasta';
import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import { TipoToasta } from '../../../../../enums/Toasta.enum';
import { AppOAuthStore } from '../../../../../models/AppOAuthSotarge';
import { httpConnect } from '../../../../../services/httpConnect.service';
import { NotificationService } from '../../../../../services/Notification.service';

@Component({
    selector: 'app-dialog-subir-archivo',
    templateUrl: '../../Views/Dialogs/dialogSubirArchivo.component.html',
    styleUrls: [
        '../../Styles/ordenDeTaller.component.scss',
        '../../../../../theme/styles/_common.scss'
    ],
    //encapsulation: ViewEncapsulation.None
})

export class DialogSubirArchivo implements OnInit {

    public archivo : any = {nombre : '', descripcion : ''}
    public _file : File | null = null;
    public files: File[] = [];
    public opciones : ToastaService;
    public configuraciones : ToastaConfig;
    public displayToasta : boolean = true;

    public imgTypes : Array<string> = ["image/png", "image/jpeg"];
    constructor( public httpConn: httpConnect,
                public dialogRef: MatDialogRef<DialogSubirArchivo>,
                private toastaService: ToastaService,
                private toastaConfig: ToastaConfig,
                private Notificacion : NotificationService,
                @Inject(MAT_DIALOG_DATA) public data: any){
        if(this.data){
            this.configuraciones = this.toastaConfig;
            this.opciones = this.toastaService;
            this.archivo = {...data.archivo};
            this._file = data.file
            this.files = this._file ? [this._file] : new Array<File>();
        }
        this.Notificacion =  new NotificationService(this.opciones, this.configuraciones);
    }

    ngOnInit(){
        if(this.data){
            console.log(this.archivo.rowNo)
        }
    }

    Examinar(){
        let i = document.getElementById("inputFile").click()
    }

    Regresar(){
        this.dialogRef.close();
    }

    handleFile(files : FileList){
        if(files){
            this._file = files.item(0);
            this.files.push(this._file)
            this.archivo.nombre = this._file.name;
        }

    }

    SubirArchivo(){
        if(this.files.length > 0){
            this.getBase64(this.files[0])
            .then(res => {
                if(this.archivo.nombre.length > 0 && (this.archivo.descripcion.length > 0 && this.archivo.descripcion.length <= 50) && this._file){
                    this.dialogRef.close({nombre : this.archivo.nombre, descripcion : this.archivo.descripcion, base64 : res, file : this._file})
                } else {
                    if (this.archivo.descripcion.length <= 0) {
                        this.Notificacion.ShowToasta('Falta agregar descripción.', TipoToasta.ADVERTENCIA);
                    } else if (this.archivo.descripcion.length > 50) {
                        this.Notificacion.ShowToasta('Se supero el lmite de caracteres (50) en campo de descripción.', TipoToasta.ADVERTENCIA);
                    }
                }
            })
        }

    }

    _subirArchivo() : Observable<any>{
        //this.dialogRef.close({nombre : this.archivo.nombre, descripcion : this.archivo.descripcion, file : this._file})
        return this.httpConn.postAPI('RegistroSiniestro', 'SaveFile', this.files)
        .pipe(
            map(res => res.response, error => throwError(error))
        )
    }

    getBase64 = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });


    onSelect(event) {
        if(this.files.length + event.addedFiles.length > 1){
            event.rejectedFiles = [event.rejectedFiles, ...event.addedFiles];
            event.addedFiles.length = 0;
        }

        if(event.rejectedFiles.length > 0){
            let _fileNames = event.rejectedFiles.map(rf => rf.name).join(', ')
            this.Notificacion.ShowToasta('Los archivos ' + _fileNames + ' no pueden ser agregados', TipoToasta.ERROR);
        }

        console.log(this.files)

        this.files.push(...event.addedFiles);
        this._file = this.files[0];
        this.archivo.nombre = this.files[0].name;
    }

    onRemove(event) {
        this.files.splice(this.files.indexOf(event), 1);
        this._file = null;
        this.archivo.nombre = '';
        this.archivo.descripcion = '';
    }
}